import { Link, Navigate, useParams } from "react-router-dom";

import { Footer } from "../components/Footer";
import { TopBar } from "../components/TopBar";
import { projects } from "../lib/projects";

export function CaseStudy() {
  const { id } = useParams();
  const index = projects.findIndex((p) => p.id === id);

  if (index === -1) return <Navigate to="/" replace />;

  const project = projects[index];
  const next = projects[(index + 1) % projects.length];

  return (
    <>
      <TopBar />
      <main className="case">
        <Link className="case__back" to="/#index">
          ← All work
        </Link>

        <header className="case__head">
          <div className="case__meta">
            <span>{project.category}</span>
            <span>{project.year}</span>
          </div>
          <h1 className="case__title">{project.name}</h1>
          <p className="case__blurb">{project.blurb}</p>
        </header>

        {project.image ? (
          <div className="case__hero">
            <img src={project.image} alt={`${project.name} preview`} />
          </div>
        ) : (
          <div className="case__hero case__hero--empty">
            <span>{project.name}</span>
          </div>
        )}

        <div className="case__body">
          <div className="case__lead">
            <span className="eyebrow">{project.role}</span>
            <p>{project.detail}</p>
          </div>
          <aside className="case__aside">
            <div>
              <h4>Stack</h4>
              <ul>
                {project.stack.map((tech) => (
                  <li key={tech}>{tech}</li>
                ))}
              </ul>
            </div>
            {project.href ? (
              <a
                className="case__visit"
                href={project.href}
                target="_blank"
                rel="noreferrer"
              >
                Visit project ↗
              </a>
            ) : null}
          </aside>
        </div>

        <Link className="case__next" to={`/work/${next.id}`}>
          <span className="eyebrow">Next project</span>
          <span className="case__next-name">{next.name} →</span>
        </Link>
      </main>
      <Footer />
    </>
  );
}
